import {
    Breadcrumbs,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import moment from "moment";
import React from "react";
import { useHistory } from "react-router-dom";

import Notify from "../../../components/notify/Notify";
import { Format } from "../../../config/config";
import RoutesEnum from "../../../routes/RoutesEnum";
import IMandant from "../../../types/IMandant";
import IPortalCommentList from "../../../types/IPortalCommentList";
import { toPortalUrl } from "../../../utils/toPortalUrl";
import { useCommentListing } from "./useCommentListing";

interface IPortalCommentListingParams {
    mandant: IMandant;
}

const CommentListing = (props: IPortalCommentListingParams) => {
    const history = useHistory();
    const { mandant } = props;
    const { commentList, snackBarState, closeSnackbar, actionMarkAsAswered, actionDeleteComment } =
        useCommentListing(mandant);

    if (!mandant.id) {
        return <></>;
    }

    function handleBread(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        event.preventDefault();
        history.push("" + event.currentTarget.dataset.url);
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link
                    color="inherit"
                    href={toPortalUrl(mandant, RoutesEnum.ADMIN_DASHBOARD)}
                    data-url={toPortalUrl(mandant, RoutesEnum.ADMIN_DASHBOARD)}
                    onClick={handleBread}
                >
                    Start
                </Link>
                <Typography color="textPrimary">Kommentare</Typography>
            </Breadcrumbs>

            <Typography variant={"h3"} className="main-header gap-top">
                Neue Kommentare
            </Typography>
            <TableContainer>
                <Table size={"small"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Datum</TableCell>
                            <TableCell>Kommentar</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>E-Mail</TableCell>
                            <TableCell>Projekt</TableCell>
                            <TableCell>Veranstaltung</TableCell>
                            <TableCell style={{ width: "100px" }}>Menu</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {commentList.map((comment: IPortalCommentList, index: number) => {
                            return (
                                <TableRow key={"user" + index}>
                                    <TableCell>{moment(comment.creationDate).format(Format.dateTime)}</TableCell>
                                    <TableCell>{comment.content}</TableCell>
                                    <TableCell>{comment.nameOfPerson}</TableCell>
                                    <TableCell>
                                        <a href={"mailto:" + comment.emailOfPerson}>{comment.emailOfPerson}</a>
                                    </TableCell>
                                    <TableCell>
                                        {
                                            //@ts-ignore
                                            comment.project?.title
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            //@ts-ignore
                                            comment.event?.title
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            data-id={comment.id}
                                            onClick={actionMarkAsAswered}
                                            component={"span"}
                                            size={"small"}
                                        >
                                            <QuestionAnswerIcon />
                                        </IconButton>
                                        <IconButton
                                            data-id={comment.id}
                                            onClick={actionDeleteComment}
                                            component={"span"}
                                            size={"small"}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Notify closeSnackbar={closeSnackbar} {...snackBarState} />
        </>
    );
};

export default CommentListing;
